import * as React from "react";
import { bannerMenuImg, FOOTER_CONTENT, SEO } from "@/constants/wxHomepage";
import { WxOurInfomation } from "../../components/our-infomation";
import { Footer } from "@/components";
import { WxBanner } from "../../components/wx-banner";
import { VerticalCard } from "../../components/vertical-card";
import { genBlock } from "@/utils/bem";
import { isWap } from "@/utils/tools";
import "./index.less";

const SCENE_DATA = [
  {
    imgUrl: require("@/assets/images/wx/icon/mingcheng.png"),
    align: "left" as "left",
    title: "菜单名称突破微信字数限制",
    descList: [
      "最多支持20个汉字,",
      "支持插入emoji表情",
      "提升粉丝点击率",
    ],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/gexinghua.png"),
    align: "left" as "left",
    title: "千人千面的个性化菜单",
    descList: [
      "可按照粉丝标签、性别、",
      "操作系统、地区、语言",
      "等条件为粉丝定制专属内容",
    ],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/duoyanghua.png"),
    align: "left" as "left",
    title: "菜单功能多样化",
    descList: [
      "支持插入粉丝昵称、表情、",
      "互动文字、跳转文字、",
      "跳转链接、跳转小程序等",
      "提升粉丝活跃度",
    ],
  },
  {
    imgUrl: require("@/assets/images/wx/icon/tongbu.png"),
    align: "left" as "left",
    title: "一键同步菜单",
    descList: ["将现有菜单一键同步至快站，", "简化设置步骤，", "提升工作效率"],
  },
];

const block = genBlock("wx-menus");

const WxMenu: React.FC<{}> = () => {

  React.useEffect(() => {
    document.querySelector('meta[name="keywords"]').setAttribute('content', SEO.mass.keyword);
    document.querySelector('meta[name="description"]').setAttribute('content', SEO.mass.description);
  }, [])

  return (
    <div className={block()}>
      <WxBanner
        img={bannerMenuImg}
        btnText="立即使用"
        btnClick={isWap() ? null : "/v3/weixin/list"}
        btnStyle={{ top: "68%" }}
      />
      <div className={block("scene")}>
        <div className={block("scene-title")}>特色功能</div>
        <div className={block("scene-wrap")}>
          {SCENE_DATA.map((item) => (
            <VerticalCard
              {...item}
              style={{ padding: "10px 20px 10px 30px" }}
            />
          ))}
        </div>
      </div>
      <WxOurInfomation />
      <Footer {...FOOTER_CONTENT} />
    </div>
  );
};

export default WxMenu;
